const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': 'https://www.babylist.com/lp/editorial-policies-guidelines',
  name: 'Babylist Editorial Process, Guidelines, and Integrity',
  description:
    "Learn about Babylist's editorial process, our content guidelines, and our commitment to integrity in our product reviews and recommendations.",
  url: 'https://www.babylist.com/lp/editorial-policies-guidelines',
  keywords:
    'babylist editorial guidelines, babylist content policy, babylist editorial standards',
  significantLinks: [
    'https://www.babylist.com/hello-baby/best-bassinets',
    'https://www.babylist.com/hello-baby/best-convertible-car-seats',
    'https://www.babylist.com/hello-baby/best-high-chairs',
    'https://www.babylist.com/hello-baby/best-baby-bottles',
    'https://www.babylist.com/hello-baby/best-diaper-bags',
    'https://www.babylist.com/hello-baby/best-baby-monitor',
    'https://www.babylist.com/hello-baby/best-baby-carriers',
    'https://www.babylist.com/hello-baby/best-breast-pump',
    'https://www.babylist.com/hello-baby/how-to-take-babys-temperature',
    'https://www.babylist.com/hello-baby/implantation',
    'https://www.babylist.com/hello-baby/early-pregnancy-symptoms',
    'https://www.babylist.com/hello-baby/what-to-pack-in-your-hospital-bag',
    'https://www.babylist.com/hello-baby/tylenol-while-pregnant',
    'https://www.babylist.com/hello-baby/how-to-store-breast-milk',
    'https://www.babylist.com/hello-baby/free-breast-pump-through-health-insurance',
    'https://www.babylist.com/hello-baby/pregnancy-week-by-week',
    'https://www.babylist.com/hello-baby/best-toys-6-month-old-baby',
    'https://www.babylist.com/hello-baby/how-many-diapers-babys-first-year',
    'https://www.babylist.com/hello-baby/how-many-baby-clothes-do-i-need',
    'https://www.babylist.com/hello-baby/best-toys-for-one-year-olds',
    'https://www.babylist.com/hello-baby/when-to-stop-swaddling',
    'https://www.babylist.com/hello-baby/best-baby-detergent',
    'https://www.babylist.com/hello-baby/best-carriers-for-toddlers',
    'https://www.babylist.com/hello-baby/best-toddler-towers',
    'https://www.babylist.com/lp/product-review-processes',
    'https://www.aap.org/',
    'https://www.cdc.gov/',
    'https://www.babylist.com/health-advisory-board',
    'https://www.babylist.com/hello-baby/authors/karen-reardanz',
    'https://www.babylist.com/hello-baby/authors/maddie-eisenhart',
    'https://www.babylist.com/hello-baby/authors/briana-engelbrecht',
    'https://www.babylist.com/hello-baby/authors/jennifer-labracio',
    'https://www.babylist.com/hello-baby/authors/amylia-ryan',
    'https://www.babylist.com/hello-baby/authors/alainna-wurfel',
  ],
  publisher: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Babylist',
    url: 'https://www.babylist.com',
    ownershipFundingInfo:
      "Babylist earns compensation from affiliate links in our content or by selling products in the Babylist Shop; however, this does not influence which products we choose to cover. Our primary goal is to share the products we've tried and loved, and we only recommended trusted retailers. We also feature sponsored content on the site. Our free site, apps and email newsletters are made possible by our sponsors. We limit our sponsored content to relevant partners that offer products and services we believe in and use ourselves, and you'll always see \"sponsored\" somewhere within the article or guide so you can distinguish it from Babylist's organic content.",
    publishingPrinciples: [
      'https://www.babylist.com/lp/editorial-policies-guidelines',
      'https://www.babylist.com/lp/product-review-processes',
    ],
    subOrganization: {
      '@type': 'NewsMediaOrganization',
      name: 'Hello Baby',
      url: 'https://www.babylist.com/hello-baby',
      verificationFactCheckingPolicy:
        "Babylist offers medically vetted health content to guide you from pregnancy to postpartum and into your parenting journey. Our writers and editors speak with accredited experts in medicine, mental health, nutrition, fitness and more to bring you fact-based content. We collaborate with Babylist's Health Advisory Board, a group of doctors, researchers and other health professionals from the fields of obstetrics and gynecology, psychology, pediatrics, nutrition and more, to feature real medical guidance in our content. The Board reviews Babylist health content for medical accuracy and we draw regularly on their knowledge and expertise to help inform our decisions and shape the practical advice we offer for parents, whether we're answering questions about keeping baby safe or giving an overview of what to expect from a certain week of pregnancy.",
      publishingPrinciples: [
        'https://www.babylist.com/lp/editorial-policies-guidelines',
        'https://www.babylist.com/lp/product-review-processes',
      ],
      ownershipFundingInfo:
        "Babylist earns compensation from affiliate links in our content or by selling products in the Babylist Shop; however, this does not influence which products we choose to cover. Our primary goal is to share the products we've tried and loved, and we only recommended trusted retailers. We also feature sponsored content on the site. Our free site, apps and email newsletters are made possible by our sponsors. We limit our sponsored content to relevant partners that offer products and services we believe in and use ourselves, and you'll always see \"sponsored\" somewhere within the article or guide so you can distinguish it from Babylist's organic content.",
    },
  },
}

export default schema
